export default __webpack_public_path__ + "static/media/closeToast.8a73a8bb.svg";